// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module--link--3Erj4"};